import { useRecency } from './use-recency';
import { DotIndicator } from 'components/atomic/atoms/dot-indicator';
import PillBadge from 'components/atomic/organisms/pill-badge';
import { semanticColors } from 'design-system';

export interface RecencyBadgeProps {
  timestamp: Date | string | null;
  locale: string;
  blur?: boolean;
}

export function RecencyBadge({ timestamp, locale, blur }: RecencyBadgeProps) {
  const { formatted, isAvailable, ariaLabel } = useRecency(timestamp, locale);

  // Don't show if blurred or no data
  if (blur || !isAvailable) {
    return null;
  }

  return (
    <span data-testid="ui-recency-badge">
      <PillBadge
        size="small"
        backgroundColor={semanticColors.recencyBg}
        textColor="#0C0F24"
        borderColor={semanticColors.recencyBorder}
        icon={<DotIndicator color="primary.main" size="md" />}
        iconPosition="left"
        ariaLabel={ariaLabel}
      >
        {formatted}
      </PillBadge>
    </span>
  );
}
